import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";

import { ContentContainerFlex } from "../pages";

import ManageNotifications from "./ManageNotifications";
import NotificationsTable from "./NotificationsTable";

import SideBarMenu from "pstat-design-system/SideBarMenu";
import { withLabelContext } from "pstat-anywhere/context_providers/LabelContext";
import { TERTIARY_NAVBAR_HEIGHT } from "pstat-anywhere/components/partials/tertiary_nav";

function SideBar({ titleName, onItemClick, activeItem, mt, top }) {
  const menuItems = [
    {
      translationKey: "notifications.sidebar.manage",
      href: "#manage"
    },
    {
      translationKey: "notifications.sidebar.myNotifications",
      href: "#mynotifications"
    }
  ];
  return (
    <SideBarMenu
      id="sidebar"
      width={[1, 1, 1 / 6]}
      p={[0, 0, 3]}
      mt={mt}
      titleName={titleName}
      menuItems={menuItems}
      forceActiveItem={activeItem}
      onItemClick={onItemClick}
      top={top}
    />
  );
}

function Notifications({ location, environment, labels, router }) {
  const { t } = useTranslation();
  const [activeItem, setActiveItem] = useState(1); // As per design

  function handleActiveItemChange(item) {
    setActiveItem(item);
  }

  const sidebarProps = {
    titleName: t("tables.notification.header"),
    activeItem: activeItem,
    onItemClick: handleActiveItemChange
  };
  if (activeItem === 0) {
    sidebarProps.top = TERTIARY_NAVBAR_HEIGHT;
  }
  const sidebar = <SideBar {...sidebarProps} />;

  return (
    <Fragment>
      {activeItem === 0 ? (
        <ManageNotifications
          labels={labels}
          environment={environment}
          sidebar={sidebar}
        />
      ) : (
        <ContentContainerFlex wrap>
          <Fragment>
            {sidebar}
            <NotificationsTable
              id="results_table"
              environment={environment}
              location={location}
              router={router}
            />
          </Fragment>
        </ContentContainerFlex>
      )}
    </Fragment>
  );
}

export default withLabelContext(Notifications);
